import { useState } from "react";
import { useParams } from "react-router-dom";
import { QrCode } from "lucide-react";

import { Button } from "@/core/components/ui/button";
import {
  QrCodesSection,
  QrScanToPayDialog,
} from "@/features/merchant/components";
import { useMerchantTranslation } from "@/features/merchant/i18n/use-merchant-translation";

/**
 * Page dédiée « QR codes » d'un marchand — génération, affichage, révocation
 * (`GET/POST /QrCodes/merchant/{merchantId}...`) et parcours scan-to-pay
 * (`GET /QrCodes/{payloadToken}` puis `POST /Transactions/initiate` avec
 * `type = MERCHANT_QR_PAYMENT`).
 */
export function QrCodesPage() {
  const { merchantId = "" } = useParams();
  const { t: tm } = useMerchantTranslation();
  const [scanOpen, setScanOpen] = useState(false);

  return (
    <section className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold text-foreground">
          {tm("merchant.qrCodes.title")}
        </h1>
        <Button variant="outline" onClick={() => setScanOpen(true)}>
          <QrCode className="mr-2 h-4 w-4" />
          {tm("merchant.qrCodes.scanToPay.title")}
        </Button>
      </div>

      <QrCodesSection key={merchantId} merchantId={merchantId} />

      <QrScanToPayDialog open={scanOpen} onOpenChange={setScanOpen} />
    </section>
  );
}
